import { useContext, useState} from "react";
import { Helmet } from "react-helmet-async";
import { Header } from "../components/Shared/Header";
import { StyleContext } from "../providers/StyleContextProvider";
import { Footer } from "../components/Shared/Footer";
import { Button } from "../components/Shared/Buttons/Button";
import { ResponseModel } from "../models/ResponseModel";
import { GetInTouch } from "../components/Shared/GetInTouch";
import { useSearchParams } from "react-router-dom";
import useErrorPage from "../hooks/useErrorPage";
import { unsubscribeEmail } from "../services/CandidateService";

export const CandidateEmailUnsubscribePage: React.FC = () => {
    const styleContext = useContext(StyleContext);
    const [searchParams] = useSearchParams();
    const styles = styleContext.getComponentStyle("candidateEmailUnsubscribePage");
    const referenceId: string = searchParams.get("id") ?? "";
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [toErrorPage] = useErrorPage();

    async function handleUnsubscribeEmail () {
        setLoading(true);
        await unsubscribeEmail(referenceId)
        .then((response: ResponseModel) => {
            setMessage(response.message);
            setIsSuccess(response.status);
            setIsSubmitted(true);
        })
        .catch((error) => {            
            toErrorPage(error);
        })
        .finally(() => {
            setLoading(false);
        });
    }

    return (
        <> 
            <Helmet><title>Candidate Email Unsubscribe - Xpressjobs</title></Helmet>
            <Header styleSheet="lowHeader" searchEnable={false} heading={"Unsubscribe Receive Jobs by Email"}/>
            <div style={styles.content}>
                {!isSubmitted
                    ? <Button style={styles.button} onClick={handleUnsubscribeEmail} disabled={loading}>UNSUBSCRIBE</Button> 
                    : <div style={isSuccess ? styles.messageSuccess : styles.messageWarning}>{message}</div>
                }
            </div>
            <GetInTouch/>
            <Footer/>
        </>
    )
}